import './SocialShareTwo.css';
// import { API_URLS } from './../../Common/Constant';
import { GetIconsSprites} from '../../../common/utils';

SocialShareTwo.version = 1000;

SocialShareTwo.lang = 'en';
SocialShareTwo.langs = [
  'en'
];
SocialShareTwo.setLang = (lang: any) => {
  SocialShareTwo.lang = lang;
}

Object.defineProperty(SocialShareTwo, 'name', {
  writable: true,
  value: 'SocialShareTwo'
});

const encodeUrl = (url: any) => {
  return encodeURIComponent(url);
}


export function SocialShareTwo(props: any) {
  // const KooAppIcon = `${API_URLS.ST_RESOURCES}/stresources/images/Koop.svg`;
  const shareText = props.shareText ? props.shareText.substring(0, 100) : '';
  const showSocialShareNew = (<div className='socialMediaWrap'>
   
    <ul className='commonSocialListWrap'>
      {props.showFacebook && (
        <li>
          <a className="toFb"
            href={`https://www.facebook.com/sharer.php?u=${props.shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`}
            target="_blank">
            {/* <FoontAwesomeIcon icon={faFacebookF} /> */}
            <div className='bg-Facebook_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </a>
        </li>)
      }
      {props.showTwitter && ( 
      <li>
        <a className="toTwitter"
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${props.shareUrl}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faTwitter} /> */}
          <div className='bg-X_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>
      )}
      {props.showWhatsapp && (
      <li>
        <a className="wtsapp"
          href={`https://api.whatsapp.com/send?text=${props.shareUrl}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faWhatsapp} /> */}
          <div className='bg-Whatsapp_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>
      )}
      {props.showLinkedin && (
      <li>
        <a className="toLinkedin"
          href={`https://www.linkedin.com/sharing/share-offsite?url=${encodeUrl(props.shareUrl)}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faLinkedinIn} /> */}
          <div className='bg-in_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </a>
         
      </li>
      )}
       {props.showInstagram && (
      <li>
        <a className="toLinkedin"
          href={`https://www.instagram.com/share?url=${encodeUrl(props.shareUrl)}&text=${encodeURIComponent(shareText)}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faInstagram} /> */}
          <div className='bg-Instagram_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </a>
          
      </li>
      )}
       {props.showYoutube && (
      <li>
        <a className="toLinkedin"
          href={`${props.shareURL_YT}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faYoutube} /> */}
          <div className='bg-Youtube_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </a>
          
      </li>
      )}
      {props.showPintrest && (
      <li>
        <a className="toPinterest"
          href={`https://in.pinterest.com/pin/create/button?url=${props.shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`} target="_blank">
          {/* <FoontAwesomeIcon icon={faPinterestP} /> */}
          <div className='bg-Pinterest_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>
      )}

    </ul >
  </div >);

  return (
    <>{showSocialShareNew}</>
  )
}
